import { Alert, Flex, notification } from 'antd';
import { BaseButton } from 'components/button/button-base';
import { ErrorListDisplay } from 'components/ErrorDisplay';
import { BaseHeader } from 'components/header';
import { Subtitle, Text, Title } from 'components/mvp-typography';
import { PrintableRootPage } from 'components/page/page-2';
import { Role } from 'features/auth/types';
import { auth } from 'lib/api/firebase';
import { useAssessmentLinkAPI } from 'lib/hooks/tanstack/use-assessmentLink';
import { useAppSelector } from 'lib/store/rootReducer';
import { resolveError } from 'lib/utils/formatters/error/resolve-error';
import { useErrorList } from 'lib/utils/useErrorList';
import { Redirect, useHistory, useParams } from 'react-router-dom';

export function AssessmentLinkPage() {
  const params = useParams<{ token?: string }>();
  const user = useAppSelector(state => state.auth.user);
  if (user?.role !== Role.Patient && user?.role !== undefined) {
    notification.warning({
      message: 'Clinicians should not access this route'
    });
    return <Redirect to={'/'} />;
  }
  return (
    <div style={{ height: '100%' }}>
      <PrintableRootPage title="">
        <BaseHeader
          headerStyle={{
            background: 'none'
          }}
        />
        {params.token !== undefined ? (
          <Body token={params.token} />
        ) : (
          <Alert
            type="error"
            message={
              'The URL is malformed. Please request a new Assessment Link.'
            }
          />
        )}
      </PrintableRootPage>
    </div>
  );
}

function Body(props: { token: string }) {
  const api = useAssessmentLinkAPI();
  const errorList = useErrorList();
  const history = useHistory();

  return (
    <Flex
      justify="center"
      align="center"
      style={{
        height: '75vh'
      }}
    >
      <Flex
        gap={16}
        vertical
        style={{
          maxWidth: '50vw'
        }}
      >
        <Flex vertical gap={16}>
          <Title>Welcome</Title>
          <Subtitle>
            You have been invited to complete a ConcussionRx assessment.
          </Subtitle>
          <Text>
            To proceed, click the &quot;Next&quot; button below.{' '}
            <b>
              If you do not have an with ConcussionRx, you will be asked to
              create one.
            </b>
          </Text>
        </Flex>
        <div>
          <BaseButton
            loading={api.consumeToken.isLoading}
            onClick={async () => {
              const token = await api.consumeToken.mutateAsync(
                { token: props.token },
                {
                  onError: error =>
                    errorList.addError(resolveError(error), 'login')
                }
              );

              await auth.signInWithCustomToken(token.signInToken);
              history.push('/');
            }}
          >
            Next
          </BaseButton>
        </div>
      </Flex>

      <ErrorListDisplay errorList={errorList} />
    </Flex>
  );
}
